import React from 'react';
import clsx from "clsx";
type Props = {
    btnText?: any,
    className?: string,
    [key: string]: any;
}

function ButtonWithoutIcon(props: Props) {
    const {className, btnText,iconName,iconClassName, ...rest} = props
    return (
        <button type={'button'} className={ clsx('button-blue ',className) }
                {...rest}>
            {btnText}

        </button>
    );
}

export default ButtonWithoutIcon;
